import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { H3, LabelRegular, ButtonRounded, ButtonRoundedPrimary, Button } from '@comeon/ui';
import { LogoBankID, Null } from '@comeon/vectors';
import { Modal } from '~/components/modal/modal.js';
import useTranslations from '~/components/translation/use-translations.ts';

const BankIDPopUp = styled.div`
	margin: 40px auto;
	width: 280px;
	background-color: var(--bankid-popup-background);
	padding: 24px 10px 5px 10px;
	display: flex;
	flex-direction: column;
	border-radius: 3px;
	align-items: center;
	text-align: center;
`;

const StyledH3 = styled(H3)`
	margin-bottom: 0;
	font: var(--h3);
`;

const StyledLabelRegular = styled(LabelRegular)`
	color: var(--bankid-popup-text);
	margin-bottom: 37px;
	width: 215px;
`;
const StyledButtonPrimary = styled(ButtonRoundedPrimary)`
	background-color: var(--bankid-popup-button);
	border-radius: 100px;
	font: var(--h4-bold);
	margin-bottom: 12px;
	white-space: normal;
	display: flex;
	align-items: center;
	justify-content: center;
`;

const BankIdContainer = styled.div`
	margin-right: 14px;
	> svg {
		width: 16px;
		height: 16px;
		.shade1,
		.shade2 {
			fill: var(--bankid-loader-middle-logo-color, var(--bankid-loader-title));
		}
	}
`;

const StyledButtonTransparent = styled(ButtonRounded)`
	font: var(--label-regular);
	color: var(--bankid-popup-transparent-button);
	margin-bottom: 12px;
	white-space: normal;
	background-color: transparent;
	border: 1px solid var(--bankid-popup-transparent-button);
	width: 100%;
`;

const StyledCancelButton = styled(Button)`
	font: var(--bankid-popup-font-cancel);
	color: var(--bankid-popup-cancel);
`;
const textKeys = [
	'BANKID_GET_STARTED',
	'BANKID_PLAY_NOW_DESCRIPTION',
	'BANKID_CONTINUE_SAME_DEVICE',
	'BANKID_CONTINUE_ANOTHER_DEVICE',
	'CANCEL'
];
const MiddleScreen = ({ bankIDCb, bankIDOtherCb, cancelCb, bankIdLoading, gaEventCb = () => {} }) => {
	const { translations } = useTranslations(textKeys);
	const [loading, setLoading] = useState(false);
	// send ga events on mount
	useEffect(() => {
		gaEventCb({
			step: 'middle-screen'
		});
	}, [gaEventCb]);
	useEffect(() => {
		if (!bankIdLoading) {
			setLoading(false);
		}
	}, [bankIdLoading]);
	return (
		<Modal show bgColor="var(--bankid-loader-bg)" withinSidebar>
			<BankIDPopUp>
				<StyledH3>{translations.BANKID_GET_STARTED}</StyledH3>
				<StyledLabelRegular mt={1}>{translations.BANKID_PLAY_NOW_DESCRIPTION}</StyledLabelRegular>
				<StyledButtonPrimary
					disabled={loading}
					onClick={() => {
						gaEventCb({
							action: 'middle-screen-same-device'
						});
						setLoading(true);
						bankIDCb();
					}}
					dataAt="register-login-bankid-button"
				>
					<BankIdContainer>
						<React.Suspense fallback={<Null />}>
							<LogoBankID />
						</React.Suspense>
					</BankIdContainer>
					{translations.BANKID_CONTINUE_SAME_DEVICE}
				</StyledButtonPrimary>
				<StyledButtonTransparent
					onClick={() => {
						gaEventCb({
							action: 'middle-screen-other-device'
						});
						bankIDOtherCb();
					}}
					dataAt="register-login-bankid-button-other-device"
				>
					{translations.BANKID_CONTINUE_ANOTHER_DEVICE}
				</StyledButtonTransparent>
				<StyledCancelButton onClick={e => cancelCb(e, true)} dataAt="register-login-bankid-cancel">
					{translations.CANCEL}
				</StyledCancelButton>
			</BankIDPopUp>
		</Modal>
	);
};

export default MiddleScreen;
